import React from 'react';
import { Button, Drawer } from 'antd';
import {
  StyledSelect,
  StyledRangePicker
} from '../styled';
import { COLORS } from '../../../constants/colors';

const { Option } = StyledSelect;

const FilterDrawer = ({ 
  visible, 
  onClose, 
  filters,
  setFilters,
  onApply,
  onClear,
  users = []
}) => {
  return (
    <Drawer
      title="Filter Audit Logs"
      placement="right"
      onClose={onClose}
      open={visible}
      width={280}
    >
      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>User</label>
        <StyledSelect
          value={filters.userId || 'all'}
          onChange={(value) => setFilters({ ...filters, userId: value === 'all' ? undefined : value })}
          style={{ width: '100%' }}
          showSearch
          optionFilterProp="children"
          placeholder="Filter by user"
        >
          <Option value="all">All Users</Option>
          {users.map(u => (
            <Option key={u._id} value={u._id}>
              {u.fullName || u.email}
            </Option>
          ))}
        </StyledSelect>
      </div>

      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Resource</label>
        <StyledSelect 
          value={filters.resource} 
          onChange={(value) => setFilters({ ...filters, resource: value })} 
          style={{ width: '100%' }}
        >
          <Option value="all">All Resources</Option>
          <Option value="Patient">Patient</Option>
          <Option value="PatientQueue">Patient Queue</Option>
          <Option value="ScreeningRecord">Screening Record</Option>
          <Option value="User">User</Option>
          <Option value="Visit">Visit</Option>
          <Option value="Client">Client</Option>
        </StyledSelect>
      </div>

      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Action</label>
        <StyledSelect 
          value={filters.action} 
          onChange={(value) => setFilters({ ...filters, action: value })} 
          style={{ width: '100%' }}
        >
          <Option value="all">All Actions</Option>
          <Option value="create">Create</Option>
          <Option value="update">Update</Option>
          <Option value="delete">Delete</Option>
          <Option value="view">View</Option>
          <Option value="export">Export</Option>
          <Option value="login">Login</Option>
          <Option value="failed_login">Failed Login</Option>
          <Option value="match">Match</Option>
        </StyledSelect>
      </div>

      <div style={{ marginBottom: 24 }}>
        <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Date Range</label>
        <StyledRangePicker
          style={{ width: '100%' }}
          value={filters.dateRange}
          onChange={(dates) => setFilters({ ...filters, dateRange: dates })}
          placeholder={['Start Date', 'End Date']}
        />
      </div>

      <div style={{ display: 'flex', gap: 8 }}>
        <Button 
          onClick={onClear}
          style={{ flex: 1 }}
        >
          Clear
        </Button>
        <Button 
          type="primary" 
          onClick={onApply}
          style={{ 
            flex: 1,
            background: COLORS.$primaryBlue,
            borderColor: COLORS.$primaryBlue
          }}
        >
          Apply
        </Button>
      </div>
    </Drawer>
  );
};

export default FilterDrawer;
